import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import VisitorNavbar from "../VisitorNavbar";
import Footer from "../Footer";

const Shipping = () => {
  const [terms, setTerms] = useState("");

  // Fetch terms from API
  const fetchTerms = async () => {
    try {
      const response = await axios.get(`${baseurl}getShipping`);
      if (response.data.data) {
        setTerms(response.data.data.data); // Set terms data
      }
    } catch (error) {
      console.error("Error fetching terms:", error);
    }
  };

  // Fetch terms on component mount
  useEffect(() => {
    fetchTerms();
  }, []);

  return (
    <>

<VisitorNavbar/>

    <div className="container mt-4">
      {/* <h2 className="text-start mb-3">Terms & Conditions</h2> */}
      <div className="card text-start p-4 mb-4">
        {terms ? (
          <div dangerouslySetInnerHTML={{ __html: terms }} />
        ) : (
          <p>Loading...</p>
        )}
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default Shipping;
